import { render, staticRenderFns } from "./payment-dialog.vue?vue&type=template&id=5e3d1e15&scoped=true"
import script from "./payment-dialog.vue?vue&type=script&lang=js"
export * from "./payment-dialog.vue?vue&type=script&lang=js"
import style0 from "./payment-dialog.vue?vue&type=style&index=0&id=5e3d1e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d1e15",
  null
  
)

export default component.exports